import CustomForumTopic from "@Components/CustomForumTopic/CustomForumTopic"
import CustomSearchBar from "@Components/CustomSearchBar/CustomSearchBar"
import { topicsCategories } from "@Constants/fakeData"
import React, { useContext, useEffect, useState } from "react"
import { ActivityIndicator, View } from "react-native"
import styles from "./styles"
import { baseColors } from "@Constants/baseStyles"
import { ForumService } from "@Services/Knowledge/SavoirEtre/Forum.Service"
import { forumData } from "../ForumLogic"
import EmptyDiscussions from "@Components/CustomTopicContent/EmptyDiscussions"
import ModalForumFilter from "./ModalForumFilter"
import ModalCreateForum from "./ModalCreateForum"
import { ForumContext } from "@Providers/ForumProvider"

export const defaultFilterValue = {
    axisId: 0,
    isFavorite: 0
}

const ForumTopic = (props) => {
    const { navigation, route } = props
    const axisId = route.params.axisId ?? 0
    const [filters, setFilters] = useState({
        axisId: axisId,
        isFavorite: 0
    })
    const { shouldUpdateForumTopic } = useContext(ForumContext)
    const [searchQuery, setSearchQuery] = useState("")
    const [updateForumList, setUpdateForumList] = useState(false)
    const [isModalVisible, setModalVisible] = useState(false)
    const [openCreateForumModal, setOpenCreateForumModal] = useState(false)
    const [forums, setForums] = useState([])
    const [fetching, setFetching] = useState(false)
    const handleFetchForums = () => {
        setFetching(true)
        ForumService.getForums(filters)
            .then((res) => {
                setForums(res?.data?.data)
                setFetching(false)
            })
            .catch(() => setFetching(false))
    }

    useEffect(() => {
        handleFetchForums()
    }, [axisId, filters, updateForumList, shouldUpdateForumTopic])

    const axisData = forumData(forums)

    const toggleModal = () => setModalVisible(!isModalVisible)
    const toggleCreateForumModal = () => setOpenCreateForumModal(!openCreateForumModal)

    const topicFiltered = topicsCategories.find((t) => t.id === filters?.axisId)
    const topic = topicFiltered

    return (
        <View style={styles.container}>
            <ModalForumFilter
                defaultAxisId={axisId}
                filters={filters}
                setFilters={setFilters}
                toggleModal={toggleModal}
                isModalVisible={isModalVisible}
            />

            <ModalCreateForum
                defaultAxisId={axisId}
                openModal={openCreateForumModal}
                toggleModal={toggleCreateForumModal}
                setUpdateForumList={setUpdateForumList}
            />

            <View style={styles.header}>
                <CustomSearchBar
                    showFilter
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    toggleModal={toggleModal}
                />
            </View>

            {fetching ? (
                <View style={styles.loading}>
                    <ActivityIndicator color={baseColors.orange.primary} size={50} />
                </View>
            ) : (
                <CustomForumTopic
                    topics={axisData}
                    title={topic.label}
                    navigation={navigation}
                    handleFetchForums={handleFetchForums}
                    fetching={fetching}
                    toggleCreateForumModal={toggleCreateForumModal}
                />
            )}
        </View>
    )
}

export default ForumTopic
